import type { ReactNode } from "react";

import { Button } from "@runcheetah/ui";
import { cn } from "@/lib/utils";

export interface SegmentedControlOption<TValue extends string> {
  value: TValue;
  label: ReactNode;
  icon?: ReactNode;
  disabled?: boolean;
}

export interface SegmentedControlProps<TValue extends string> {
  options: readonly SegmentedControlOption<TValue>[];
  value: TValue;
  onChange: (value: TValue) => void;
  className?: string;
  buttonClassName?: string;
}

export function SegmentedControl<TValue extends string>({
  options,
  value,
  onChange,
  className,
  buttonClassName,
}: SegmentedControlProps<TValue>) {
  return (
    <div
      className={cn(
        "flex flex-wrap gap-1 rounded-full border border-border/70 bg-card p-1",
        className,
      )}
    >
      {options.map((option) => (
        <Button
          key={option.value}
          variant={value === option.value ? "default" : "ghost"}
          size="sm"
          className={cn("rounded-full", option.icon ? "gap-2" : null, buttonClassName)}
          disabled={option.disabled}
          onClick={() => onChange(option.value)}
        >
          {option.icon}
          {option.label}
        </Button>
      ))}
    </div>
  );
}
